import { render, staticRenderFns } from "./GuidanceConfig.vue?vue&type=template&id=cf26e7de"
import script from "./GuidanceConfig.vue?vue&type=script&lang=js"
export * from "./GuidanceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf26e7de')) {
      api.createRecord('cf26e7de', component.options)
    } else {
      api.reload('cf26e7de', component.options)
    }
    module.hot.accept("./GuidanceConfig.vue?vue&type=template&id=cf26e7de", function () {
      api.rerender('cf26e7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/GuidanceConfig.vue"
export default component.exports